import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListItems, getMixedListValues, nullDate, TDate } from '../../public/utility'
import { doGetBonusApplication, doSaveBonusApplication, doDeleteBonusApplication } from '../../reducers/actions'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import SelectSalaryIssueDiv from './SelectSalaryIssueDiv'
import { values } from 'lodash'
// import { doBonusApplicationAction } from '../../business/BonusApplicationAction'
class BonusApplicationDeatil extends React.Component {
    state = {
        changedValues基本信息: {},
        bSave: false
    }

    componentDidMount = () => {
        this.doGetBonusApplication(this.props.id)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGetBonusApplication = (id) => {
        const { dispatch, taskName } = this.props
        dispatch(doGetBonusApplication({
            id: id || 0,
            taskName,
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ bSave: false })
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        }))
    }

    handlerSave = () => {
        const { dispatch, onSave, onClose, 奖金期号 } = this.props
        const { changedValues基本信息, id, bSave } = this.state
        if (!bSave) {
            const { list: list奖金明细 } = Tyan.utility.getListItems(this, '基本信息', '奖金明细')
            this.setState({ bSave: true })
            dispatch(doSaveBonusApplication({
                id,
                奖金期号,
                list奖金明细,
                changedValues基本信息,
                onEnd: ({ errorMessage, id }) => {
                    if (errorMessage) {
                        this.setState({ bSave: false })
                        Tyan.pubForm.showError(errorMessage)
                    } else {
                        Ext.toast('保存成功')
                        this.setState({ id })
                        this.doGetBonusApplication(id)
                    }
                }
            }))
        }
    }

    handlerDelete = () => {
        const { dispatch, onSave, onClose } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            dispatch(doDeleteBonusApplication({
                id,
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    } else {
                        Ext.toast('删除成功')
                        onClose && onClose()
                    }
                }
            })))
    }

    handelSubmit = (action, title) => {
        const { onSave, onClose, dispatch, showDetail } = this.props
        const { id } = this.state
        doBonusApplicationAction(dispatch, title, { id: id, action: action, onSave: this.handlerClose, showDetail: showDetail })
    }


    handelExportBonus = () => {
        const { id } = this.props
        Tyan.pubForm.showExport({ event: 'ExportBonus', eventData: { id }, title: '导出奖金明细' })
    }

    handleExportBonusSummary = () => {
        const { id } = this.props
        Tyan.pubForm.showExport({ event: 'ExportBonusSummary', eventData: { id }, title: '导出年终奖金汇总表' })
    }

    handelSetSalaryIssue = () => {
        const { id } = this.props
        Tyan.pubForm.showDialog('设置', props => <SelectSalaryIssueDiv {...props} id={id} onSave={() => this.doGetBonusApplication(id)} />)
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0 && values.申请原因
    }

    fieldset奖金记录 = () => {
        const { optionsParas } = this.state
        const 显示列 = optionsParas['显示列']
        const p = { margin: '5px 5px 5px 5px', minWidth: 1, _full: true, flex: 1, clearable: false }
        const { list: 奖金明细 } = Tyan.utility.getListItems(this, '基本信息', '奖金明细')
        return [
            {
                _group: '', minWidth: '95%', items: [
                    { _text: '奖金期号', minWidth: '250', disabled: true, flex: 2 },
                    { _text: '申请人', minWidth: '250', disabled: true, flex: 2 },
                    { _text: '发放月份', name: '薪资期号', minWidth: '250', disabled: true, flex: 2 },
                    { _int: '人数', minWidth: '250', disabled: true, flex: 2 },
                    { _text: '申请原因', minWidth: '250', required: true, flex: 5 },
                ]
            },
            {
                _group: '', minWidth: '95%', items: [
                    {
                        _group: '', name: '标题', items: [
                            { _label: '员工编号', disabled: true, ...p, },
                            { _label: '员工姓名', disabled: true, ...p, },].concat(显示列 && 显示列.map(o => {
                                return { _label: o.name, disabled: true, ...p, align: 'right' }
                            }))
                    },
                ].concat(奖金明细 && 奖金明细.map(({ id }) => {
                    const list = { listName: '奖金明细', id }
                    return {
                        _group: '', minWidth: '95%', /* dynamicRender: true, */ items: [
                            { _text: '', name: '员工编号', list, disabled: true, ...p, },
                            { _text: '', name: '员工姓名', list, disabled: true, ...p, },].concat(显示列 && 显示列.map(n => {
                                return { _float: '', name: n.name, list, ...p, disabled: !n.edit }
                            }))
                    }
                }).concat([{ _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } },
                { _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }
                ]))
            },]
    }

    render() {
        const { showMessage: Message, showBody: Body, readOnly } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态, 提交时间 } = initValues基本信息
        return <Body data={this}
            controls={
                readOnly ? [
                    { _button: '导出', icon: 'save', handler: () => this.handelExportBonus(), /* cdt: () => 状态 == 3,  */ },
                    { _button: '导出年终奖金汇总表', icon: 'save', handler: () => this.handleExportBonusSummary(), },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ] : [
                    { _button: '导出', icon: 'save', handler: () => this.handelExportBonus(), /* cdt: () => 状态 == 3, */ },
                    { _button: '导出年终奖金汇总表', icon: 'save', handler: () => this.handleExportBonusSummary(), },
                    { _button: '发放月份设置', icon: 'save', handler: () => this.handelSetSalaryIssue(), cdt: () => 状态 == 1, },
                    { _flow: 'BonusApplyFlow', disabled: this.bSave(), cdt: () => id > 0, id: getFormValue(this, '基本信息', 'ArchivesID') },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: () => this.handlerDelete(), cdt: () => id > 0 && 状态 == 1 && 提交时间 == nullDate, disabled: this.bSave() },
                    {
                        _button: '保存', icon: 'save', handler: () => this.handlerSave(), cdt: () => 状态 == 1, disabled: !this.bSave()
                    },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '奖金申请', name: '基本信息', _fieldset: this.fieldset奖金记录(), minWidth: '1500', forceDisabled: 状态 !== 1 },
                ]
            }
        />
    }
}

export default connect()(BonusApplicationDeatil)